export default __webpack_public_path__ + "maps-examples-runtime-multiple-annotations-1200-55d2e290026e503b13b8d927f4081d30.webp";